/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Subtext_GoneInputs */



/**
* | output |
* | --- |
* | "Whatever was here, it's gone now." |
*
* @param {Error_Notfound_Subtext_GoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_subtext_gone = /** @type {((inputs?: Error_Notfound_Subtext_GoneInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Subtext_GoneInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was auch immer hier war, es ist weg.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce qui était ici a disparu.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这里原本有什么，现在都没了。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("不論這裡本來有什麼，現在都不見了。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("여기 있던 것이 무엇이든 지금은 사라졌습니다.")
	return /** @type {LocalizedString} */ ("Whatever was here, it's gone now.")
});